import { useCallback, useEffect, useMemo, useState } from "react";

export default function useLocalStorageObj(storageKey, defaultObj = {}) {

  // LOAD
  const loadObj = useCallback(() => {
    const loadedItem = localStorage.getItem(storageKey);
    if ( Boolean(loadedItem) && loadedItem !== 'null' && loadedItem !== 'undefined') {
      try {
        const parsedObj = JSON.parse(loadedItem);
        return parsedObj;
      }
      catch(error) {
        console.error('[useLocalStorageObj loadObj] Parse Error [storageKey: %s] [loadedItem: %s] Returning Default [defaultObj: %s]',storageKey, loadedItem, defaultObj);
        return defaultObj;
      }
    }
    else {
      return defaultObj;
    }
  }, [defaultObj, storageKey]);

  // SAVE
  const saveObj = useCallback((anObj) => {
    localStorage.setItem(storageKey, JSON.stringify( anObj )); // must stringify - because this is serialization! not simply saving a string!    
  }, [storageKey]);

  const [state, setState] = useState(loadObj());

  useEffect(()=>{
    if (state) {
      saveObj(state);
    }
  }, [state, saveObj]);


  return {
    getObj: useMemo( ()=> state, [state]),
    setObj: setState
  }
}
